// extracted by mini-css-extract-plugin
export default {"infiniteScroll":"styles_infiniteScroll__n+xUp"};